import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const usePositionStore = create()(persist((set) => ({
    currentCoords: undefined,
    setCurrentCoords: (currentCoords) => set({ currentCoords }),
    getLocation: ({ onSuccess, onError }) => {
        const success = (position) => {
            set({ currentCoords: position.coords });
            onSuccess();
        };
        const error = () => {
            set({ currentCoords: undefined });
            onError();
        };
        if (navigator) {
            navigator.geolocation.getCurrentPosition(success, error);
        }
    },
}), {
    name: 'geoPermission',
    storage: createJSONStorage(() => localStorage),
}));
